import { ARC_ENVIRONMENT } from './arc-env';
// AWS ALB limit: 100 rules per listener, 1 rule per member (nginx sidecar). Using 90 for safety margin.
const SharedAlbConfigs = {
  dev: {
    count: 3,
    membersPerAlb: 90
  },
  staging: {
    count: 2,
    membersPerAlb: 90
  },
  prod: {
    count: 5,
    membersPerAlb: 90
  }
};
export const ARC_SHARED_ALB_CONFIG = SharedAlbConfigs[ARC_ENVIRONMENT];